import React, { useEffect, useState } from "react";
import NavBar from "../components/NavBar";
import MyApps from "../components/home-page-components/MyApps";
import TraineryHCM from "../components/home-page-components/TraineryHCM";
import TraineryTRAK from "../components/home-page-components/TraineryTrak2";
import Footer from "../components/Footer";
import "./styles/notifications.css";
import Axios from "../api/Axios";
import { useDispatch } from "react-redux";
import { userData } from "../store/slices/UserInfo";
import { useNavigate, useSearchParams } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
// import SystemNotifications from "../components/SystemNotifications";
// eslint-disable-next-line no-unused-vars
// import UpcomingEvents from "../components/UpcomingEvents";
import { setTnmisSubmenu } from "../store/slices/tnmisSubmenu";
import { setSubMenuClick } from "../store/slices/SubMenuClick";
import { setSubMenuTrakL } from "../store/slices/SubMenuTrakL";
import Resources from "../components/home-page-components/Resources";
// import Podcasts from "../components/home-page-components/Podcasts";
import Webinars from "../components/home-page-components/Webinars";
import ConatctJer from "../components/home-page-components/ConatctJer";
import ProductAnnouncements from "../components/home-page-components/ProductAnnouncements";
import { allowedRoles } from "../components/icons/ApplicationColor";
import Spinner from "../components/Spinner";
import dayjs from "dayjs";
import NotificationsModal from "../components/legacyComp/tetsing/NotificationsModal";
import { REDIRECT_LEARNING, REDIRECT_COACHING } from "../config";
const Notifications = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState();
  const [homePageData, setHomePageData] = useState();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  console.log(redirect, searchParams);
  const dispatch = useDispatch();
  const history = useNavigate();
  const redirectUser = async () => {
    try {
      const res = await Axios.get("/auth-user/");
      setData(res.data);
      dispatch(userData(res.data));
      const isAdmin = res.data.roles.some((app) =>
        allowedRoles.includes(app.key_name)
      );
      if (isAdmin) {
        localStorage.setItem("isAdmin", "true");
        //console.log("role set");
      } else {
        localStorage.removeItem("isAdmin");
      }
      //console.log(res);
      //console.log(res.data?.is_superadmin);
      if (res.data?.is_superadmin) {
        localStorage.setItem("superadmin", "is-super-admin");
      } else {
        localStorage.setItem("superadmin", "is-normal-user");
      }
      HomePageGet();

      customNotifications();
    } catch (err) {
      if (err.response?.status === 403 || err.response?.status === 401) {
        //console.log("----coming here----");
        localStorage.removeItem("token");
        localStorage.clear();
        history("/");
      } else {
        //console.log("----coming here----");
        localStorage.removeItem("token");
        localStorage.clear();
        history("/");
      }
    }
  };
  const customNotifications = async () => {
    try {
      const res = await Axios.get("/customnotificationevent/");
      console.log(res);
      setFormData(res?.data);
    } catch (err) {
      console.log(err);
    }
  };
  const HomePageGet = async () => {
    try {
      const res = await Axios.get("/homepagecontent/");
      console.log(res);
      setHomePageData(res?.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  useEffect(() => {
    redirectUser();
    dispatch(setTnmisSubmenu(false));
    dispatch(setSubMenuClick(false));
    dispatch(setSubMenuTrakL(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [maintenanceFormData, setMaintenanceFormData] = useState([]);
  const [productFormData, setProductFormData] = useState([]);

  const [maintenanceLinks, setMaintenanceLinks] = useState({});
  const [productLinks, setProductLinks] = useState({});

  useEffect(() => {
    if (
      formData &&
      data?.custom_notification?.custom_notification_exists
      // data?.custom_notification?.mandatory_read
    ) {
      console.log("Setting customPoints:", formData);

      // Function to transform notification data
      const transformData = (data) =>
        data.map((item) => ({
          id: item?.id,
          sub_category: item?.sub_category || "",
          priority: item?.priority || "",
          title: item?.notification_content || "",
          status: item?.status ?? true,
          application: item?.application || "",
          dateRange:
            item?.start_date && item?.end_date
              ? [
                  dayjs(item.start_date).startOf("minute"),
                  dayjs(item.end_date).startOf("minute"),
                ]
              : [],
          customPoints:
            item?.custompoints?.length > 0
              ? item.custompoints.map((point) => ({ point: point.point || "" }))
              : [{ point: "" }],
          bullet_point: item?.bullet_point || false,
          customhtml: item?.customhtml || "",
        }));

      // Extract and transform maintenance notifications (single array)
      if (formData?.maintenance_notifications?.length) {
        setMaintenanceFormData(
          transformData(formData.maintenance_notifications)
        );

        // Set Maintenance Links
        const formattedMaintenanceLinks = {};
        formData.maintenance_notifications.forEach((item, index) => {
          if (item.custompoints?.length) {
            formattedMaintenanceLinks[index] = item.custompoints.map(
              (point) => ({
                name: point.linkName || "",
                url: point.linkUrl || "",
              })
            );
          }
        });
        setMaintenanceLinks(formattedMaintenanceLinks);
      }

      // Extract and transform product notifications (separate array)
      if (formData?.product_notifications?.length) {
        setProductFormData(transformData(formData.product_notifications));

        // Set Product Links
        const formattedProductLinks = {};
        formData.product_notifications.forEach((item, index) => {
          if (item.custompoints?.length) {
            formattedProductLinks[index] = item.custompoints.map((point) => ({
              name: point.linkName || "",
              url: point.linkUrl || "",
            }));
          }
        });
        setProductLinks(formattedProductLinks);
      }
    }
  }, [loading, formData, data]);
  const [applications, setApplications] = useState([]);
  useEffect(() => {
    const LoadUser = async () => {
      try {
        const res = await Axios.get("/traineryoneapplictaionlist/");
        //console.log(res.data);
        setApplications(res.data);
      } catch (err) {
        //console.log(err);
      }
    };
    LoadUser();
  }, []);
  console.log(
    maintenanceFormData,
    productFormData,
    maintenanceLinks,
    productLinks
  );
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    // Show modal only if there are notifications
    if (maintenanceFormData.length > 0 || productFormData.length > 0) {
      setModalVisible(true);
    }
  }, [maintenanceFormData, productFormData]);
  const [dontShow, setDontShow] = useState(false);
  const handleDontShowChange = (e) => {
    setDontShow(e.target.checked); // Store the state but don't call the API yet
  };
  const handleModalClose = async () => {
    setModalVisible(false);

    if (dontShow) {
      const allNotificationIds = [
        ...maintenanceFormData.map((item) => item.id),
        ...productFormData.map((item) => item.id),
      ];

      if (allNotificationIds.length > 0) {
        const queryString = `notification_ids=[${allNotificationIds.join(
          ","
        )}]`;
        try {
          await Axios.get(`/customnotificationevent/mark_read/?${queryString}`);

          if (data?.default_application?.name && redirect === true) {
            switch (data?.default_application.name) {
              case "Trak Learning":
                window.location.href = REDIRECT_LEARNING;
                break;
              case "Trak Coaching":
                window.location.href = REDIRECT_COACHING;
                break;
              default:
                if (data?.default_application?.url) {
                  window.location.href = data?.default_application?.url;
                }
            }
          }
        } catch (error) {
          console.error("Error marking notifications as read:", error);
        }
      }
    } else {
      if (data?.default_application?.name && redirect === true) {
        switch (data?.default_application.name) {
          case "Trak Learning":
            window.location.href = REDIRECT_LEARNING;
            break;
          case "Trak Coaching":
            window.location.href = REDIRECT_COACHING;
            break;
          default:
            if (data?.default_application?.url) {
              window.location.href = data?.default_application?.url;
            }
        }
      }
    }
  };

  return (
    <>
      {loading ? (
        <div style={{ display: "grid", placeItems: "center", height: "100vh" }}>
          <Spinner />
        </div>
      ) : (
        <>
          <div className="main-body" style={{ background: "#f4f4f4" }}>
            <header>
              <NavBar data={data} />
            </header>
            {/* <div className="privacy-container-2"> */}

            <div className="main-container-2">
              <div>
                <div className="top-section-add">
                  <div className="add-links">
                    <ProductAnnouncements
                      data={[
                        ...(homePageData?.blogs?.News || []),
                        ...(homePageData?.blogs?.Blog || []),
                      ]}
                    />

                    <div style={{ padding: "10px" }}></div>
                    <Webinars data={homePageData?.webinars} />
                  </div>
                </div>
                <div
                  className="below-section-add"
                  style={{ marginTop: "20px" }}
                >
                  <div className="add-links-2">
                    <Resources
                      data={[
                        ...(homePageData?.brochures || []),
                        ...(homePageData?.blogs?.["White Papers"] || []),
                      ]}
                    />
                    <div style={{ padding: "10px" }}></div>
                    {/* <div className="container-grid-ops-2"> */}
                    {/* <div className="something2">
                        <Podcasts
                          data={homePageData?.blogs?.["White Papers"]}
                        />
                      </div> */}

                    <ConatctJer />
                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div className="first">
                <MyApps data={data} />
                <TraineryTRAK data={data} applications={applications} />
                <TraineryHCM data={data} applications={applications} />
              </div>
              {/* <div className="second">
                <SystemNotifications />
                <UpcomingEvents />
              </div> */}
            </div>
            <footer>
              <Footer />
            </footer>
            <NotificationsModal
              maintenanceNotifications={maintenanceFormData}
              productNotifications={productFormData}
              maintenanceLinks={maintenanceLinks}
              productLinks={productLinks}
              applications={applications}
              visible={modalVisible}
              onClose={handleModalClose}
              dontShow={dontShow}
              onDontShowChange={handleDontShowChange}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Notifications;
